import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import style from './index.scss';
import logo from '../../../assets/logo.png';
import sandbox_ss from '../../../assets/sandbox_ss.png';
import { getVersionNumber, isResourceAvailable } from '../../../util/index';
import { getItemFromLocalStorage } from '../../../util/localStorageUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAbacus,
  faLaptop,
  faTasks,
  faListAlt,
  faTicket,
  faSearchLocation
} from '@fortawesome/pro-regular-svg-icons';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import CMSidebarItems from '../../cm/SidebarItems';

import { getCurrentAppByPath } from '../appUtils';
import {
  ROUTE_AMLS_NS_SAM,
  ROUTE_AMLS_SMART_SCREENING
} from '../../constants/globalConstants';
import { getSelectedResources } from '../../../util/resourceManager';
const {
  crsResources,
  nsResources,
  sandboxResources,
  tmResources,
  trmResources
} = getSelectedResources();

const Sidebar = (props) => {
  let {
    appName,
    menuCollaps,
    selectedItem,
    toggleMenu,
    changeActiveItem,
    navigateTo,
    authentication,
    location
  } = props;

  let nsRiskViewPermitted = false;
  let nsInvestigationPagePermitted = false;
  let nsAlertsListingPermitted = false;
  let nsSegmentsListingPermitted = false;
  let nsMatchingConfigPermitted = false;
  let nsMatchingRunInstancePermitted = false;
  let nsWatchListPermitted = false;
  let nsWhiteListPermitted = false;
  let nsGlobalSettingsPermitted = false;
  let nsTicketsPermitted = false;
  let nsSandboxPermitted = false;
  let nsOnDemandScreeningPermitted = false;

  let tmRiskViewPermitted = false;
  let tmAlertsListingPermitted = false;
  let tmGlobalSettingsPermitted = false;

  // let trmConfigurationPermitted = false;
  // let trmGlobalSettingsPermitted = false;

  let tmInvestigationPagePermitted = false;
  let crsCustomerListPermitted = false;
  let crsRiskIndicatorConfigurationPermitted = false;
  let crsGlobalSettingsPermitted = false;

  let homeUrl = '';

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    // first attribute will be the home URL
    const homeAttribute = listOfAttributes[0];

    // home attribute resource code
    const homeAttributeResourceCode = homeAttribute.details?.resource
      ?.operations?.[0]
      ? homeAttribute.details?.resource?.operations?.[0]
      : null;

    switch (homeAttributeResourceCode) {
      case nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST:
        homeUrl = `${ROUTE_AMLS_NS_SAM}/investigation`;
        break;

      case nsResources.APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE:
        homeUrl = `${ROUTE_AMLS_NS_SAM}/investigation`;
        break;

      case nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW:
        homeUrl = `${ROUTE_AMLS_NS_SAM}/dashboard`;
        break;

      case nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG:
        homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`;
        break;

      case nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE:
        homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/runInstance`;
        break;

      case nsResources.APP_3_RESOURCE_UI_NS_IAD_WATCHLIST:
        homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/watchlist`;
        break;

      case nsResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET:
        homeUrl = `${ROUTE_AMLS_SMART_SCREENING}/tickets`;
        break;

      case nsResources.APP_3_RESOURCE_UI_SCREENING_SANDBOX:
        homeUrl = '/sandbox/ns';
        break;

      case tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS:
        homeUrl = '/tm/investigation';
        break;

      case tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES:
        homeUrl = '/tm/investigation';
        break;

      case tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE:
        homeUrl = '/tm/investigation';
        break;

      case tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD:
        homeUrl = '/tm/dashboard';
        break;

      case tmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS:
        homeUrl = '/tm/settings';
        break;

      case crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST:
        homeUrl = '/crs/customers';
        break;
      case crsResources.APP_3_RESOURCE_UI_CRS_DASHBOARD:
        homeUrl = '/crs/dashboard';
        break;
      case crsResources.APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS:
        homeUrl = '/crs/settings';
        break;
    }

    // list down permissions for each page for NS

    listOfAttributes.map((attribute) => {
      const scopes = attribute.details?.resource?.operations
        ? attribute.details.resource.operations
        : null;
      if (scopes) {
        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST)) {
          nsAlertsListingPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_SEGMENTS)) {
          nsSegmentsListingPermitted = true;
        }

        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE)
        ) {
          nsInvestigationPagePermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW)) {
          nsRiskViewPermitted = true;
        }

        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG)
        ) {
          nsMatchingConfigPermitted = true;
        }

        if (
          scopes.includes(
            nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE
          )
        ) {
          nsMatchingRunInstancePermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_WATCHLIST)) {
          nsWatchListPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_IAD_WHITELIST)) {
          nsWhiteListPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET)) {
          nsTicketsPermitted = true;
        }

        if (
          scopes.includes(nsResources.APP_3_RESOURCE_UI_ON_DEMAND_SCREENING)
        ) {
          nsOnDemandScreeningPermitted = true;
        }

        if (
          scopes.includes(sandboxResources.APP_3_RESOURCE_UI_SCREENING_SANDBOX)
        ) {
          nsSandboxPermitted = true;
        }

        if (
          scopes.includes(
            nsResources.APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS
          ) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          nsGlobalSettingsPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS)
        ) {
          tmAlertsListingPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES)
        ) {
          tmAlertsListingPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE)
        ) {
          tmInvestigationPagePermitted = true;
        }

        if (scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD)) {
          tmRiskViewPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          tmGlobalSettingsPermitted = true;
        }

        if (scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST)) {
          crsCustomerListPermitted = true;
        }

        if (
          scopes.includes(
            crsResources.APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION
          ) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          crsRiskIndicatorConfigurationPermitted = true;
        }

        if (
          scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          crsGlobalSettingsPermitted = true;
        }
      }
    });
  }

  const nameSpace = getCurrentAppByPath(location.pathname);

  try {
    const href = window.location.href;
    if (href && href.indexOf('/dashboard') >= 0) selectedItem = 1;
    if (href && href.indexOf('/investigation') >= 0) selectedItem = 2;
  } catch (e) {}

  let siderItems = null;
  const locationNew = window.location;
  const { pathname } = locationNew;
  const splitLocation = pathname.split('/');

  let nsDashboardNavigation = '';
  if (nsRiskViewPermitted) {
    nsDashboardNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: `${ROUTE_AMLS_NS_SAM}/dashboard`,
            state: {
              pagename: 'ns'
            }
          }}>
          <i className="fa fa-home fa-2x"></i>
          <br />
          <span className={style.parentText}>RISK VIEW</span>
        </Link>
      </li>
    );
  }

  let nsAlertsListingNavigation = '';
  if (nsAlertsListingPermitted) {
    nsAlertsListingNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: `${ROUTE_AMLS_NS_SAM}/investigation`,
            state: {
              pagename: 'ns'
            }
          }}>
          <i className="fa fa-eye fa-2x"></i>
          <br />
          <span className={style.parentText}>INVESTIGATION</span>
        </Link>
      </li>
    );
  }

  let nsSegmentsListingNavigation = '';
  if (nsSegmentsListingPermitted) {
    nsSegmentsListingNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/segments`,
            state: {
              pagename: 'ns'
            }
          }}>
          <i className="fa fa-th-large"></i>
          <br />
          <span className={style.parentText}>SEGMENTS</span>
        </Link>
      </li>
    );
  }

  let nsMatchingConfigNavigation = null;
  if (nsMatchingConfigPermitted) {
    nsMatchingConfigNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="1">
        <Link
          className={
            splitLocation[3] === 'matchingConfig'
              ? style.active
              : style.linkItem
          }
          //className={style.linkItem}
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`,
            state: {
              pagename: 'ns'
            }
          }}>
          <FontAwesomeIcon icon={faAbacus} style={{ fontSize: '22px' }} />
          <br />
          <span className={style.parentText}>MATCHING CONFIG</span>
        </Link>
      </li>
    );
  }

  let nsMatchingRunInstanceConfigNavigation = null;
  if (nsMatchingRunInstancePermitted) {
    nsMatchingRunInstanceConfigNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={
            splitLocation[3] === 'runInstance' ? style.active : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/runInstance`,
            state: {
              pagename: 'ns'
            }
          }}>
          <span className="fa-layers fa-fw" style={{ width: '2.5em' }}>
            <FontAwesomeIcon icon={faLaptop} style={{ fontSize: '22px' }} />
            <FontAwesomeIcon
              icon={faPlay}
              style={{ marginBottom: '5px', fontSize: '6px' }}
            />
          </span>
          <br />
          <span className={style.parentText}>Run Instance</span>
        </Link>
      </li>
    );
  }

  let nsWatchlistNavigation = null;
  if (nsWatchListPermitted) {
    nsWatchlistNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="3">
        <Link
          className={
            splitLocation[3] === 'watchlist' ? style.active : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/watchlist`,
            state: {
              pagename: 'ns'
            }
          }}>
          <FontAwesomeIcon icon={faListAlt} style={{ fontSize: '22px' }} />
          <br />
          <span className={style.parentText}>Watchlist</span>
        </Link>
      </li>
    );
  }

  let nsWhitelistNavigation = null;
  if (nsWhiteListPermitted) {
    nsWhitelistNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="4">
        <Link
          className={
            splitLocation[3] === 'whitelist' ? style.active : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/whitelist`,
            state: {
              pagename: 'ns'
            }
          }}>
          <FontAwesomeIcon icon={faTasks} style={{ fontSize: '22px' }} />
          <br />
          <span className={style.parentText}>Whitelist</span>
        </Link>
      </li>
    );
  }

  let nsTicketsNavigation = null;
  if (nsTicketsPermitted) {
    nsTicketsNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="5">
        <Link
          className={
            splitLocation[3] === 'tickets' ? style.active : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/tickets`,
            state: {
              pagename: 'ns'
            }
          }}>
          <FontAwesomeIcon icon={faTicket} style={{ fontSize: '22px' }} />
          <br />
          <span className={style.parentText}>Tickets</span>
        </Link>
      </li>
    );
  }

  let nsOnDemandScreeningNavigation = null;
  if (nsOnDemandScreeningPermitted) {
    nsOnDemandScreeningNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="on-demand">
        <Link
          className={
            splitLocation[3] === 'on-demand-screening'
              ? style.active
              : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/on-demand-screening`,
            state: {
              pagename: 'ns'
            }
          }}>
          <img src={sandbox_ss} alt="on-demand-screening" />
          <br />
          <span className={style.parentText}>On Demand Screening</span>
        </Link>
      </li>
    );
  }

  let nsSandboxNavigation = null;
  if (nsSandboxPermitted) {
    nsSandboxNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="5">
        <Link
          className={
            splitLocation[3] === 'sandbox' ? style.active : style.linkItem
          }
          to={{
            pathname: '/app/sandbox/ns',
            state: {
              pagename: 'sandbox'
            }
          }}>
          <img src={sandbox_ss} alt="sandbox_ss" title="logo" />
          <br />
          <span className={style.parentText}>Sandbox</span>
        </Link>
      </li>
    );
  }

  let nsGlobalSettingsNavigation = null;
  if (nsGlobalSettingsPermitted) {
    nsGlobalSettingsNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}
        key="6">
        <Link
          className={
            splitLocation[3] === 'settings' ? style.active : style.linkItem
          }
          to={{
            pathname: `${ROUTE_AMLS_SMART_SCREENING}/settings`,
            state: {
              pagename: 'ns'
            }
          }}>
          <i className="fa fa-gear fa-2x"></i>
          <br />
          <span className={style.parentText}>SETTINGS</span>
        </Link>
      </li>
    );
  }

  let crsCustomerListViewNavigation = null;
  if (crsCustomerListPermitted) {
    crsCustomerListViewNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: '/app/crs/customers',
            state: {
              pagename: 'crs'
            }
          }}>
          <i className="fa fa-home fa-2x"></i>
          <br />
          <span className={style.parentText}>Customer's List</span>
        </Link>
      </li>
    );
  }

  let crsGlobalSettingsNavigation = null;
  if (crsGlobalSettingsPermitted) {
    crsGlobalSettingsNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: '/app/crs/settings',
            state: {
              pagename: 'tm'
            }
          }}>
          <i className="fa fa-gear fa-2x"></i>
          <br />
          <span className={style.parentText}>SETTINGS</span>
        </Link>
      </li>
    );
  }

  let crsRiskIndicatorConfigurationNavigation = null;
  if (crsRiskIndicatorConfigurationPermitted) {
    crsRiskIndicatorConfigurationNavigation = (
      <li
        className={classNames(
          menuCollaps ? style.accordionCollaps : style.accordion
        )}>
        <Link
          className={style.linkItem}
          to={{
            pathname: '/app/crs/riskIndicatorConfiguration',
            state: {
              pagename: 'crs'
            }
          }}>
          <i className="fa fa-dashboard fa-2x"></i>
          <br />
          <span className={style.parentText}>Configure Risk Indicators</span>
        </Link>
      </li>
    );
  }

  if (nameSpace == 'tm') {
    siderItems = (
      <ul className={style.accordionList}>
        {tmRiskViewPermitted ? (
          <li
            className={classNames(
              menuCollaps ? style.accordionCollaps : style.accordion
            )}>
            <Link
              className={style.linkItem}
              to={{
                pathname: '/app/tm/dashboard',
                state: {
                  pagename: 'tm'
                }
              }}>
              <i className="fa fa-home fa-2x"></i>
              <br />
              <span className={style.parentText}>RISK VIEW</span>
            </Link>
          </li>
        ) : null}
        {tmAlertsListingPermitted || tmInvestigationPagePermitted ? (
          <li
            className={classNames(
              menuCollaps ? style.accordionCollaps : style.accordion
            )}>
            <Link
              className={style.linkItem}
              to={{
                pathname: '/app/tm/investigation',
                state: {
                  pagename: 'tm'
                }
              }}>
              <i className="fa fa-eye fa-2x"></i>
              <br />
              <span className={style.parentText}>INVESTIGATION</span>
            </Link>
          </li>
        ) : null}
        {tmGlobalSettingsPermitted ? (
          <li
            className={classNames(
              menuCollaps ? style.accordionCollaps : style.accordion
            )}>
            <Link
              className={style.linkItem}
              to={{
                pathname: '/app/tm/settings',
                state: {
                  pagename: 'tm'
                }
              }}>
              <i className="fa fa-gear fa-2x"></i>
              <br />
              <span className={style.parentText}>SETTINGS</span>
            </Link>
          </li>
        ) : null}

        {/* <li className={classNames(menuCollaps?style.accordionCollaps : style.accordion)}>
        <Link className={style.linkItem} to={{
          pathname: '/app/tm/settings',
          state: {
            pagename: 'tm'
          }
        }}>
        <i className="fa fa-gear fa-2x"></i><br />
        <span className={style.parentText}>SETTINGS</span>
        </Link>
      </li> */}

        {/* FOR THE SAKE OF DEMO REQUEST
      hasPermission(authentication, "tm_dashboard_riskview") && hasPermission(authentication, "tm_dashboard_operation") ?
        <BarItem activeTabID={selectedItem === 1} text="DASHBOARD" faIcon="fa-home"
        isCollaps={menuCollaps}
        onActiveItemChange={() => {changeActiveItem(1)}}
        subItems={[
          {
            text: "RISK VIEW",
            link: `/app/tm/dashboard/riskview`,
            modu: "tm_dashboard_riskview"
          },
          // {
          //   text: "OPERATION VIEW",
          //   link: `/app/tm/dashboard/operation`,
          //   modu: "tm_dashboard_operation"
          // }
        ]}
      /> : null
      <BarItem activeTabID={selectedItem === 2} text="INVESTIGATION" linkTo={`/app/${nameSpace}/investigation`} faIcon="fa-eye"
        isCollaps={menuCollaps}
        onActiveItemChange={() => {changeActiveItem(2)}}
        subItems={[
          {
            text: "ALERTS INVESTIGATION",
            link: `/app/tm/investigation`,
            modu: "tm_invest_unit",
          },
          // {
          //   text: "GENERATE REPORTS",
          //   link: `/app/tm/investigation/reports`,
          //   modu: "tm_invest_unit",
          // }
        ]}
        authentication={ authentication}
      />*/}
      </ul>
    );
  } else if (appName === 'crs') {
    siderItems = (
      <ul className={style.accordionList}>
        {crsCustomerListViewNavigation}
        {crsRiskIndicatorConfigurationNavigation}
        {crsGlobalSettingsNavigation}
      </ul>
    );
  } else if (appName === 'ns') {
    siderItems = (
      <ul className={style.accordionList}>
        {nsDashboardNavigation}
        {nsAlertsListingNavigation}
      </ul>
    );
  } else if (appName === 'smart-screening') {
    siderItems = (
      <ul className={style.accordionList}>
        {nsDashboardNavigation}
        {nsAlertsListingNavigation}
        {nsMatchingConfigNavigation}
        {nsMatchingRunInstanceConfigNavigation}
        {nsWatchlistNavigation}
        {nsSegmentsListingNavigation}
        {nsWhitelistNavigation}
        {nsTicketsNavigation}
        {nsOnDemandScreeningNavigation}
        {nsGlobalSettingsNavigation}
      </ul>
    );
  } else if (appName === 'cm') {
    siderItems = (
      <CMSidebarItems menuCollapse={menuCollaps} styleClasses={style} />
    );
  } else if (appName === 'framl') {
    siderItems = (
      <ul className={style.accordionList}>
        <li
          className={classNames(
            menuCollaps ? style.accordionCollaps : style.accordion
          )}>
          <Link
            className={style.linkItem}
            to={{
              pathname: '/app/framl',
              state: {
                pagename: 'framl'
              }
            }}>
            <FontAwesomeIcon
              icon={faSearchLocation}
              style={{ fontSize: '22px' }}
            />
            <br />
            <span className={style.parentText}>FRAML View</span>
          </Link>
        </li>
      </ul>
    );
  } else if (appName === 'sandbox') {
    siderItems = <ul className={style.accordionList}>{nsSandboxNavigation}</ul>;
  } else {
    let TMIAD_TypologyListingPage = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY
    );
    let TMIAD_trmTypologyUploadPage = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY_WRITE
    );
    let TMIAD_trmTicketListingPage = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET
    );
    let TMIAD_scenarioListingPage = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE
    );
    let TMIAD_deployInProduction = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_CHAMPION
    );
    let TMIAD_globalSettingsPermitted = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS
    );

    siderItems = (
      <ul className={style.accordionList}>
        {/* FOR THE SAKE OF DEMO REQUEST
      hasPermission(authentication, "ns_dashboard_riskview") && hasPermission(authentication, "ns_dashboard_operation") ?
        <BarItem activeTabID={selectedItem === 1} text="DASHBOARD" faIcon="fa-home"
        isCollaps={menuCollaps}
        onActiveItemChange={() => {changeActiveItem(1)}}
        subItems={[
          {
            text: "RISK VIEW",
            link: `/app/ns/dashboard/riskview`,
            modu: "ns_dashboard_riskview"
          },
          // {
          //   text: "OPERATION VIEW",
          //   link: `/app/ns/dashboard/operation`,
          //   modu: "ns_dashboard_operation"
          // }
        ]}
      /> : null}
      <BarItem activeTabID={selectedItem === 2} text="INVESTIGATION" faIcon="fa-eye"
        isCollaps={menuCollaps}
        onActiveItemChange={() => {changeActiveItem(2)}}
        subItems={[
          // {
          //   text: "Supervisor Dashboard",
          //   link: `/app/ns/investigation/supervisordashboard`,
          //   modu: "ns_invest_unit",
          //   func: "supervisor_view"
          // },
          {
            text: "Alert Investigation",
            link: `/app/ns/investigation`,
            modu: "ns_invest_unit",
            func: "view_alert_detail"
          },
          // {
          //   text: 'Analyst Throughput',
          //   link: `/app/ns/investigation/analystthroughput`,
          //   modu: "ns_invest_unit",
          //   func: "analyst_view"
          // }
        ]}
        authentication={ authentication}
      />*/}

        <>
          {TMIAD_TypologyListingPage && (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/dashboard',
                  state: {
                    pagename: 'tm'
                  }
                }}>
                <i className="fa fa-tasks"></i>
                <br />
                <span className={style.parentText}>TYPOLOGY LISTING</span>
              </Link>
            </li>
          )}
          {TMIAD_scenarioListingPage && (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/run-instance',
                  state: {
                    pagename: 'tm'
                  }
                }}>
                <i className="fa fa-clone"></i>
                <br />
                <span className={style.parentText}>RUN INSTANCE LISTING</span>
              </Link>
            </li>
          )}
          {TMIAD_trmTypologyUploadPage && (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/upload',
                  state: {
                    pagename: 'tm'
                  }
                }}>
                <i className="fa fa-upload fa-2x"></i>
                <br />
                <span className={style.parentText}>TYPOLOGY UPLOADING</span>
              </Link>
            </li>
          )}

          {TMIAD_trmTicketListingPage && (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/tickets',
                  state: {
                    pagename: 'tm'
                  }
                }}>
                <i className="fa fa-ticket fa-2x"></i>
                <br />
                <span className={style.parentText}>Tickets Dashboard</span>
              </Link>
            </li>
          )}
          {/* {trmConfigurationPermitted && (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/configuration',
                  state: {
                    pagename: 'trm'
                  }
                }}>
                <i className="fa fa-cogs fa-2x"></i>
                <br />
                <span className={style.parentText}>CONFIGURATION</span>
              </Link>
            </li>
          )} */}
          {TMIAD_globalSettingsPermitted ? (
            <li
              className={classNames(
                menuCollaps ? style.accordionCollaps : style.accordion
              )}>
              <Link
                className={style.linkItem}
                to={{
                  pathname: '/app/trm/settings',
                  state: {
                    pagename: 'trm'
                  }
                }}>
                <i className="fa fa-gear fa-2x"></i>
                <br />
                <span className={style.parentText}>SETTINGS</span>
              </Link>
            </li>
          ) : null}
        </>
      </ul>
    );
  }

  return (
    <div
      className={classNames(
        menuCollaps ? style.wrapperCollaps : style.wrapper,
        'clearfix'
      )}>
      <nav id={style.sidebar}>
        <div
          className={style.sidebarHeader}
          onClick={() => {
            navigateTo('/app/');
          }}>
          <img src={logo} alt="tookitaki" title="logo" />
          <div style={{ fontSize: 12, color: '#ffffff' }}>FinCense</div>
          <div style={{ fontSize: 12, color: '#ffffff' }}>
            {getVersionNumber()}
          </div>
        </div>
        <a
          id={style.menuToggle}
          onClick={() => toggleMenu()}
          className="pull-right">
          <i
            className={classNames(
              'fa',
              menuCollaps ? 'fa-chevron-right' : 'fa-chevron-left'
            )}
            aria-hidden="true"></i>
        </a>
        {siderItems}
      </nav>
    </div>
  );
};

Sidebar.propTypes = {
  appName: PropTypes.string,
  navigateTo: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func,
  changeActiveItem: PropTypes.func,
  menuCollaps: PropTypes.bool,
  selectedItem: PropTypes.number
};

export default Sidebar;
